import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";
import "sonner/dist/styles.css";

const DEFAULT_TOAST_TIMEOUT = 6000;

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
    const { theme = "system" } = useTheme();

    return (
        <Sonner
            theme={theme as ToasterProps["theme"]}
            // eslint-disable-next-line tailwindcss/no-custom-classname
            className="toaster group"
            toastOptions={{
                unstyled: true,
                classNames: {
                    icon: "hidden",
                },
                duration: DEFAULT_TOAST_TIMEOUT,
            }}
            {...props}
        />
    );
};

export default Toaster;
